import React, { useState } from "react";
import "./Modal.css";

/**
 * Modal for editing an existing API user's name and email.
 */
function EditUserModal({ user, onClose, onSubmit, loading }) {
  const [name, setName] = useState(user.name || "");
  const [email, setEmail] = useState(user.email || "");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!name.trim()) {
      setError("Name is required.");
      return;
    }
    if (!email.trim() || !email.includes("@")) {
      setError("A valid email is required.");
      return;
    }

    try {
      await onSubmit({ id: user.id, name: name.trim(), email: email.trim() });
    } catch (err) {
      setError(err.message || "Failed to update user.");
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Edit User</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="modal-error">{error}</div>}

            <div className="modal-field">
              <label htmlFor="edit-name">Name</label>
              <input
                id="edit-name"
                type="text"
                placeholder="Enter user name"
                maxLength={24}
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
              <span className="modal-field-hint">Max 24 characters</span>
            </div>

            <div className="modal-field">
              <label htmlFor="edit-email">Email</label>
              <input
                id="edit-email"
                type="email"
                placeholder="Enter user email"
                maxLength={56}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="modal-field-hint">Max 56 characters</span>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUserModal;
